/**
 * Format seconds to MM:SS format
 * Shared across all music services
 */
export const formatTime = (seconds: number): string => {
  // Handle negative numbers by treating them as 0
  const positiveSeconds = Math.max(0, seconds)
  const mins = Math.floor(positiveSeconds / 60)
  const secs = Math.floor(positiveSeconds % 60)
  return `${mins}:${secs.toString().padStart(2, '0')}`
}
